import React from "react";
import PropTypes from "prop-types";
import { Input } from "rbx";

function ZipCodeInput({ name, value, onChange, readOnly, tabIndex }) {
  return (
    <Input
      autocomplete="new"
      maxLength="10"
      name={name}
      readOnly={readOnly}
      tabIndex={tabIndex}
      type="text"
      value={value}
      onChange={onChange}
    />
  );
}
ZipCodeInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  tabIndex: PropTypes.string
};

export default ZipCodeInput;
